var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveBtnChatbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#DEECFE",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6001 21.6001V26.8001H26.8001V21.6001M24.2001 21.6001H37.2001L42.4001 26.8001V39.8001C42.4001 40.4897 42.1262 41.151 41.6386 41.6386C41.151 42.1262 40.4897 42.4001 39.8001 42.4001H24.2001C23.5105 42.4001 22.8492 42.1262 22.3616 41.6386C21.874 41.151 21.6001 40.4897 21.6001 39.8001V24.2001C21.6001 23.5105 21.874 22.8492 22.3616 22.3616C22.8492 21.874 23.5105 21.6001 24.2001 21.6001ZM29.4001 34.6001C29.4001 35.2897 29.674 35.951 30.1616 36.4386C30.6492 36.9262 31.3105 37.2001 32.0001 37.2001C32.6897 37.2001 33.351 36.9262 33.8386 36.4386C34.3262 35.951 34.6001 35.2897 34.6001 34.6001C34.6001 33.9105 34.3262 33.2492 33.8386 32.7616C33.351 32.274 32.6897 32.0001 32.0001 32.0001C31.3105 32.0001 30.6492 32.274 30.1616 32.7616C29.674 33.2492 29.4001 33.9105 29.4001 34.6001Z",
    stroke: "#0857C3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveBtnChatbox);
export default __webpack_public_path__ + "static/media/save-btn-chatbox.503acbc41ca81a0c54db63aaabbdffa7.svg";
export { ForwardRef as ReactComponent };